import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { Button } from '@/components/ui/button';
import { getEggGif, loadUploadedGifs, subscribeToCacheUpdates } from '../utils/helpers';

const EggView = () => {
  const navigate = useNavigate();
  const [eggGif, setEggGif] = useState(null);

  useEffect(() => {
    const loadEggGif = async () => {
      await loadUploadedGifs();
      setEggGif(getEggGif());
    };
    loadEggGif();
    // Subscribe to cache updates
    const unsubscribe = subscribeToCacheUpdates(() => {
      setEggGif(getEggGif());
    });
    return () => unsubscribe();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 to-indigo-50 flex items-center justify-center px-4">
      <div className="w-full max-w-2xl text-center">
        <h1 className="text-4xl md:text-5xl font-outfit font-black text-slate-900 mb-4" data-testid="egg-view-title">
          Você recebeu um Ovo!
        </h1>
        <p className="text-xl text-slate-600 font-nunito mb-8">
          Seu professor está preparando seu monstro. Aguarde enquanto ele escolhe a classe e choca o ovo!
        </p>

        <div className="bg-white rounded-3xl border-2 border-slate-100 p-12 shadow-lg mb-8 relative overflow-hidden">
          <div className="absolute inset-0 bg-gradient-to-br from-yellow-50 to-orange-50 opacity-50"></div>
          <div className="relative">
            <div className="w-64 h-64 mx-auto mb-6 flex items-center justify-center">
              {eggGif ? (
                <img
                  src={eggGif}
                  alt="Egg"
                  className="max-w-full max-h-full object-contain drop-shadow-2xl"
                  data-testid="egg-gif"
                />
              ) : (
                <div className="text-9xl">🥚</div>
              )}
            </div>
            <div className="flex justify-center gap-2 mb-4">
              <div className="w-3 h-3 bg-yellow-500 rounded-full animate-pulse"></div>
              <div className="w-3 h-3 bg-orange-500 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
              <div className="w-3 h-3 bg-red-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
            </div>
            <p className="text-slate-600 font-nunito text-lg">
              Aguardando o professor escolher sua classe...
            </p>
          </div>
        </div>

        <Button
          data-testid="back-to-dashboard-btn"
          onClick={() => navigate('/student/dashboard')}
          className="bg-primary hover:bg-primary/90 text-white h-14 px-12 rounded-xl text-lg font-bold shadow-lg transition-all"
        >
          Voltar para Dashboard
        </Button>

        <div className="mt-8 grid grid-cols-3 gap-4">
          <div className="bg-white rounded-xl p-4 border-2 border-blue-100">
            <div className="text-3xl mb-2">🛡️</div>
            <p className="text-sm font-nunito font-bold text-slate-700">Tank</p>
            <p className="text-xs text-slate-500">Alta defesa</p>
          </div>
          <div className="bg-white rounded-xl p-4 border-2 border-red-100">
            <div className="text-3xl mb-2">⚔️</div>
            <p className="text-sm font-nunito font-bold text-slate-700">Atacante</p>
            <p className="text-xs text-slate-500">Alto ataque</p>
          </div>
          <div className="bg-white rounded-xl p-4 border-2 border-green-100">
            <div className="text-3xl mb-2">💚</div>
            <p className="text-sm font-nunito font-bold text-slate-700">Suporte</p>
            <p className="text-xs text-slate-500">Cura e apoio</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EggView;
